import React, { useState } from "react";
import styled from "styled-components";
import { FiCopy, FiCheck } from "react-icons/fi";

const HashContainer = styled.div`
  display: flex;
  align-items: center;
  font-family: ${({ theme }) => theme.fontFamily.mono};
  position: relative;
  cursor: pointer;
`;

const HashText = styled.span`
  word-break: break-word;
`;

const CopyButton = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.textMuted};
  cursor: pointer;
  padding: 4px;
  margin-left: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.colors.verae[500]};
  }

  &:focus {
    outline: none;
  }
`;

interface HashCodeProps {
  hash: string;
  className?: string;
}

export const HashCode: React.FC<HashCodeProps> = ({ hash, className }) => {
  const [copied, setCopied] = useState(false);

  const shortenHash = (hash: string) => {
    if (!hash) return "Unknown";
    if (hash.length <= 16) return hash;
    return `${hash.substring(0, 8)}...${hash.substring(hash.length - 8)}`;
  };

  const copyToClipboard = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigator.clipboard.writeText(hash).then(() => {
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 1500);
    });
  };

  return (
    <HashContainer className={className} onClick={copyToClipboard} title={hash}>
      <HashText>{shortenHash(hash)}</HashText>
      <CopyButton>
        {copied ? <FiCheck style={{ color: '#4caf50' }} /> : <FiCopy />}
      </CopyButton>
    </HashContainer>
  );
};
